import {calendarStore} from "../store/calendar-store";
import dashboardStore from "../store/dashboard-store";
import {calendarViewModel} from "../view-model/professional/calendar-view-model";

export function updateStatusBookingShareStore(id: string, status: 'confirmed' | 'cancelled' | 'completed') {
    calendarStore.updateAppointment(id, status)
    dashboardStore.updateAppointment(id, status)
    calendarViewModel.convertToCalendarEvents()
}